export default "__VITE_ASSET__226cfd6c__"